import { type DotLottie, DotLottieReact } from "@lottiefiles/dotlottie-react";
import { useEffect, useState } from "react";

import src from "./animations/Confetti.json?url";
import styles from "./Confetti.module.css";

export function Confetti({ onComplete }: { onComplete?: () => void }) {
    const [dotLottie, setDotLottie] = useState<DotLottie | null>(null);

    // Fire onComplete so the parent can unmount the <canvas> (FullStory renders a persistent one as a hatch).
    useEffect(() => {
        if (!dotLottie || !onComplete) return;
        dotLottie.addEventListener("complete", onComplete);
        return () => dotLottie.removeEventListener("complete", onComplete);
    }, [dotLottie, onComplete]);

    return (
        <DotLottieReact
            className={styles.player}
            src={src}
            speed={0.5}
            loop={false}
            autoplay
            dotLottieRefCallback={setDotLottie}
        />
    );
}
